import { IconButton, styled } from '@mui/material';
export const LinkIconButton = styled(IconButton)(({ theme }) => ({
    borderRadius: `var(--gp-radius-lg)`,
    padding: theme.spacing(2),
    ':hover': {
        backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 5%, transparent)`,
    },
}));
